import { Component } from '@angular/core';

@Component({
    selector: 'singleview-link',
    template: `
	<label  (click) = "navigateToDetailPage()" style="cursor:pointer"  [ngStyle]="{'color': color}"> {{value}} </label>`,
    standalone: false
})

export class GridSingleviewLinkComponent {

	public params: any;
	value: any;
	color;
	constructor() { }
	agInit(params: any): void {
		this.params = params;
		this.value = this.params.data.alarm;
		this.color = this.params.data.alarmTypeId.trim() == 'E' ? 'red' : 'blue' // NOSONAR
	}

	navigateToDetailPage() {
		this.params.context.componentParent.redirectToDetailPage(this.params.data);

	}
}